import pick from 'lodash/pick';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

class Captcha {
    constructor(app) {
        this.app = app;
    }
    refresh(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.validateToken = undefined;
            const { captcha_token, captcha_url } = yield this.app.request({
                method: 'GET',
                path: '/1.1/requestCaptcha',
                query: pick(options, ['width', 'height', 'size', 'ttl']),
            }, options);
            this.token = captcha_token;
            this.url = captcha_url;
            return this;
        });
    }
    verify(code, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.token) {
                throw new Error('验证码 token 为空，请刷新验证码后重试');
            }
            const { validate_token } = yield this.app.request({
                method: 'POST',
                path: '/verifyCaptcha',
                body: {
                    captcha_code: code,
                    captcha_token: this.token,
                },
            }, options);
            this.validateToken = validate_token;
            return this.validateToken;
        });
    }
}

class Cloud {
    constructor(app) {
        this.app = app;
    }
    getServerTime() {
        return __awaiter(this, void 0, void 0, function* () {
            const { iso } = (yield this.app.request({
                method: 'GET',
                path: '/1.1/date',
            }));
            return new Date(iso);
        });
    }
    requestCaptcha(options) {
        return new Captcha(this.app).refresh(options);
    }
    run(funcName, param = {}, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { result } = yield this.app.request({
                method: 'POST',
                service: 'engine',
                path: `/1.1/functions/${funcName}`,
                header: (options === null || options === void 0 ? void 0 : options.production) === undefined
                    ? undefined
                    : {
                        'X-LC-Prod': options.production ? undefined : '0',
                    },
                body: this.app.database().encode(param),
            }, options);
            return result;
        });
    }
    rpc(funcName, param = {}, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const db = this.app.database();
            const { result } = yield this.app.request({
                method: 'POST',
                service: 'engine',
                path: `/1.1/call/${funcName}`,
                header: (options === null || options === void 0 ? void 0 : options.production) === undefined
                    ? undefined
                    : {
                        'X-LC-Prod': options.production ? undefined : '0',
                    },
                body: db.encode(param),
            }, options);
            return db.decode(result);
        });
    }
    sendPushNotification(data, options) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if ((options === null || options === void 0 ? void 0 : options.expirationTime) && (options === null || options === void 0 ? void 0 : options.expirationInterval)) {
                throw new Error('Cannot set both expirationTime and expirationInterval');
            }
            yield this.app.request({
                service: 'push',
                method: 'POST',
                path: '/1.1/push',
                body: {
                    data,
                    where: (_a = options === null || options === void 0 ? void 0 : options.query) === null || _a === void 0 ? void 0 : _a.params.where,
                    channels: options === null || options === void 0 ? void 0 : options.channels,
                    push_time: (_b = options === null || options === void 0 ? void 0 : options.pushTime) === null || _b === void 0 ? void 0 : _b.toISOString(),
                    expiration_time: (_c = options === null || options === void 0 ? void 0 : options.expirationTime) === null || _c === void 0 ? void 0 : _c.toISOString(),
                    expiration_interval: options === null || options === void 0 ? void 0 : options.expirationInterval,
                    notification_id: options === null || options === void 0 ? void 0 : options.notificationId,
                    req_id: options === null || options === void 0 ? void 0 : options.reqId,
                    prod: options === null || options === void 0 ? void 0 : options.prod,
                    topic: options === null || options === void 0 ? void 0 : options.topic,
                    apns_team_id: options === null || options === void 0 ? void 0 : options.apnsTeamId,
                    flow_control: options === null || options === void 0 ? void 0 : options.flowControl,
                    _notificationChannel: options === null || options === void 0 ? void 0 : options.notificationChannel,
                },
            }, options);
        });
    }
    requestSMSCode(mobilePhoneNumber, options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.request({
                method: 'POST',
                path: '/1.1/requestSmsCode',
                body: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.variables), { mobilePhoneNumber, smsType: options === null || options === void 0 ? void 0 : options.smsType, ttl: options === null || options === void 0 ? void 0 : options.ttl, name: options === null || options === void 0 ? void 0 : options.name, op: options === null || options === void 0 ? void 0 : options.op, template: options === null || options === void 0 ? void 0 : options.template, sign: options === null || options === void 0 ? void 0 : options.sign, validate_token: options === null || options === void 0 ? void 0 : options.validateToken }),
            }, options);
        });
    }
    verifySMSCode(mobilePhoneNumber, smsCode, options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.request({
                method: 'POST',
                path: `/1.1/verifySmsCode/${smsCode}`,
                body: { mobilePhoneNumber },
            }, options);
        });
    }
}

const cloudModule = {
    name: 'cloud',
    components: { Cloud },
    onLoad: ({ modules }) => {
        const { App } = modules.core.components;
        App.prototype.cloud = function () {
            return new Cloud(this);
        };
    },
};

export { Cloud, cloudModule };
